import {default as React, FunctionComponent} from 'react'
import { RouteComponentProps } from 'react-router'
import Splash from '../components/Splash'
import withAccountAndBranch from '../common/withAccountAndBranch'
import { IBranch, IAccount, IUser } from '../types/user'

interface IRouteParams {
  productId?: string
}

interface IOwnProps {
  user: IUser
  branch: IBranch
  account?: IAccount
}

const Plan: FunctionComponent<
  RouteComponentProps<IRouteParams> & IOwnProps
> = ({ match, user, branch, account: currentAccount, history }) => {
  const account = currentAccount || user.account

  if (!branch || !account) return <Splash isLoading />

  const branchId = branch.id
  const accountId = account.id

  return (
    <iframe
      className="replenishment_iframe"
      src={`/clients/${accountId}/replenishment-plan/${branchId}?embedded=true`}
    />
  )
}

export default withAccountAndBranch(Plan)
